/* eslint-disable no-use-before-define */
import * as React from 'react';

import type { FormValidator } from 'types';

type Validator = {
  valid: boolean | undefined | null,
  messages: Array<string>
};

type Props = {
  children: React.ReactNode,
  validators: Array<FormValidator>,
  onValidate: (a: Validator) => unknown,
  onResetValidation: () => void,
  registerValidators: (b: Validatable, a: Array<FormValidator>) => void,
  unregisterValidators: (a: Validatable) => void
};

class Validatable extends React.Component<Props> {
  static defaultProps = {
    validators: []
  };

  componentDidMount() {
    const { registerValidators } = this.props;

    if (registerValidators) {
      registerValidators(this, this.props.validators);
    }
  }

  componentWillUnmount() {
    const { unregisterValidators } = this.props;

    if (unregisterValidators) {
      unregisterValidators(this);
    }
  }

  validate(): boolean {
    const validators = this.props.validators;
    const invalidValidators = validators.filter(v => !v.valid);
    const messages = invalidValidators.map(v => v.message);

    this.props.onValidate({
      valid: invalidValidators.length === 0,
      messages
    });

    return invalidValidators.length === 0;
  }

  resetValidation(): void {
    this.props.onResetValidation();
  }

  render(): React.ReactNode {
    return React.Children.only(this.props.children);
  }
}

export default Validatable;
